import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output, computed, input } from '@angular/core';
import { CurrencyAtomComponent } from '../currency-atom/currency-atom.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-button-square-atom',
  templateUrl: './button-square-atom.component.html',
  standalone: true,
  imports: [CommonModule, CurrencyAtomComponent, TranslateModule],
  host: { class: 'contents' },
})
export class ButtonSquareAtomComponent {
  readonly text = input<string>();
  readonly value = input<number>();
  readonly type = input<'currency' | 'percent' | undefined>(undefined);
  readonly full = input(false);
  readonly isActive = input(false);
  /**
   * When set (e.g. percent choice resolved to currency), shown under the primary line
   * and emitted on click instead of value().
   */
  readonly secondaryAmount = input<number | undefined>(undefined);
  readonly otherAmount = input<number>();

  protected readonly clickPayload = computed(() => {
    const secondary = this.secondaryAmount();
    if (secondary !== undefined && secondary !== null) {
      return secondary;
    }
    return this.value() ?? 0;
  });

  @Output() buttonClick = new EventEmitter<number>();

  constructor() {}
}
